import Clarity from '@microsoft/clarity';
import { logEvent, setUserProperties } from 'firebase/analytics';
import { analytics } from 'src/libs/firebase';
import { consumeLanguageChange, language, languageSource } from 'src/locales/tr';

const RETRY_MS = 500;
const MAX_ATTEMPTS = 20;

export const reportLanguage = () => {
  const previous = consumeLanguageChange();
  let attempts = 0;

  const send = () => {
    if (!analytics) {
      attempts += 1;
      if (attempts < MAX_ATTEMPTS) setTimeout(send, RETRY_MS);
      return;
    }
    setUserProperties(analytics, {
      app_language: language,
      app_language_source: languageSource
    });
    if (previous) {
      logEvent(analytics, 'language_changed', { from: previous, to: language });
    }
  };

  send();

  try {
    Clarity.setTag('app_language', language);
    Clarity.setTag('app_language_source', languageSource);
  } catch (err) {
    console.warn(err);
  }
};
